// extracted by mini-css-extract-plugin
export default {"container":"Yda-z","innerContainer":"Zda-z","multipleLines":"_da-z","heading":"aea-z","content":"bea-z","linkColor":"cea-z"};